import { Link } from 'react-router-dom';

const linkStyle = { color: 'inherit', textDecoration: 'underline', textUnderlineOffset: '3px', padding: '4px 2px', display: 'inline-block', minHeight: 24 };

// The Terms of Service and Privacy Policy, one muted line wherever the home
// page ends.
export function LegalLinks({ style }) {
  return (
    <nav aria-label="Legal" className="flex justify-center items-center gap-2" style={{ fontSize: '12.5px', color: 'var(--ledger-faint)', ...style }}>
      <Link to="/terms" style={linkStyle}>Terms of Service</Link>
      <span aria-hidden="true">·</span>
      <Link to="/privacy" style={linkStyle}>Privacy Policy</Link>
    </nav>
  );
}

export default LegalLinks;
